import React from "react";
import injectStores from "../RootStore/injectStores";
// import ScheduleGridStore from 'stores/ScheduleGridStore/ScheduleGridStore';
import { renderDate } from "@intrasync/utils";
import { ScheduleGridBodyCellProps } from "./ScheduleGrid.Types";

const styles = {
  display: "flex",
  alignItems: "center",
  border: "1px solid #eee",
  padding: "0px",
  justifyContent: "center",
  flexDirection: "column",
};

export const LeftBodyCell = injectStores(
  (props: ScheduleGridBodyCellProps) => {
    const {
      namespaceId = "",
      style,
      rowIndex,
      scheduleGridStore,
      columnIndex,
    } = props;
    // console.log('LeftBodyCell', namespaceId);
    const currentStore = scheduleGridStore?.namespaces[namespaceId];
    // console.log('currentStore', currentStore);
    const currentEntity = currentStore?.currentRows[rowIndex];

    const rowCount =
      currentEntity && "entities" in currentEntity
        ? currentEntity.entities.length
        : 0;

    const currentHeader =
      currentStore?.currentColumnHeaders?.[columnIndex] ?? null;
    // console.log('LeftBodyCell currentHeader', currentHeader);

    const scheduleDate =
      currentEntity && "schedulerDate" in currentEntity
        ? currentEntity.schedulerDate
        : undefined;

    if (currentHeader?.bodyComponent) {
      const Component = currentHeader.bodyComponent;
      // console.log('RightHeaderCell Component', Component);
      return React.cloneElement(<Component />, {
        currentStore,
        currentHeader,
        styles,
        scheduleDate,
        rowCount,
        rowData: currentEntity,
        ...props,
      });
    }

    return (
      <div
        key={`left-header-cell-${namespaceId}-${rowIndex}`}
        title={undefined}
        style={{
          ...style,
          ...styles,
          flexDirection: "column",
          height: (typeof style?.height === "number" ? style.height : 0) - 2,
          width: (typeof style?.width === "number" ? style.width : 0) - 2,
        }}
      >
        {scheduleDate && <b>{renderDate(scheduleDate)}</b>}
        {rowCount > 1 && <b>{rowCount} items</b>}
      </div>
    );
  }
);

export default LeftBodyCell;
